//React
import React from 'react';

// mui
import { TextField, Box, Typography, Grid } from '@mui/material';

//interfaces

// libs
import i18n from '../i18n';

// utils
import { getStorageLinks, isEmpty, handleErr, getValidationMessage } from '../utils/util';

// configurations
import DeviceBreakPoints from '../configurations/deviceBreakpoints';
export var TextFieldsDisplay = function TextFieldsDisplay(props) {
  var _props$fieldItem;
  var _DeviceBreakPoints = DeviceBreakPoints(),
    isSmallDevice = _DeviceBreakPoints.isSmallDevice;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    sx: {
      display: 'grid',
      gridTemplateColumns: isSmallDevice ? '1fr' : '1fr 1fr',
      columnGap: '42px'
    }
  }, props === null || props === void 0 || (_props$fieldItem = props.fieldItem) === null || _props$fieldItem === void 0 ? void 0 : _props$fieldItem.map(function (innerItem, outerIndex) {
    if (!Array.isArray(innerItem)) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: innerItem.fieldName
      }, props === null || props === void 0 ? void 0 : props.callback(innerItem, outerIndex));
    } else {
      var _innerItem$;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        key: (_innerItem$ = innerItem[0]) === null || _innerItem$ === void 0 ? void 0 : _innerItem$.fieldName,
        sx: {
          justifyContent: 'space-between'
        }
      }, innerItem.map(function (fieldItem, index) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: fieldItem.fieldName
        }, props === null || props === void 0 ? void 0 : props.callback(fieldItem, index));
      }));
    }
  }));
};
var dropDownComponent = function dropDownComponent(environment, dropDownIconFlag) {
  return /*#__PURE__*/React.createElement(Box, {
    component: 'img',
    src: getStorageLinks(environment).cdn + '/assets/img/dropdown-downarrow.svg',
    sx: {
      display: dropDownIconFlag ? 'none' : 'block',
      width: '27px',
      filter: 'brightness(0.5)!important',
      position: 'absolute!important',
      right: '10px !important',
      pointerEvents: 'none !important'
    }
  });
};
var TextFieldComponent = function TextFieldComponent(props) {
  var _props$fieldItem8, _props$fieldValue, _props$fieldItem9, _props$fieldItem11, _props$fieldValue2, _props$fieldItem12, _props$fieldItem14, _props$fieldItem15, _props$fieldItem16, _props$fieldItem17, _props$fieldItem18, _props$fieldItem19, _props$fieldItem20, _props$fieldItem21, _props$fieldItem22, _props$fieldItem23, _props$fieldItem24, _props$fieldItem28, _props$fieldItem29, _props$fieldItem30, _props$fieldItem31, _props$fieldItem32, _props$fieldItem33;
  var getFieldError = function getFieldError() {
    var fieldValue = props === null || props === void 0 ? void 0 : props.fieldValue;
    var fieldItem = props === null || props === void 0 ? void 0 : props.fieldItem;
    var hasValidValues = fieldValue && (fieldItem === null || fieldItem === void 0 ? void 0 : fieldItem.regexPattern);
    var fieldError = false;
    if (hasValidValues && fieldItem.regexPattern) {
      var _fieldItem$regexPatte;
      var regexPattern = new RegExp(fieldItem === null || fieldItem === void 0 || (_fieldItem$regexPatte = fieldItem.regexPattern) === null || _fieldItem$regexPatte === void 0 ? void 0 : _fieldItem$regexPatte.source, fieldItem.regexPattern.flags);
      fieldError = !regexPattern.test(fieldValue);
    }
    return fieldError;
  };
  var getHelperText = function getHelperText(mandatoryError) {
    if (mandatoryError && props !== null && props !== void 0 && props.displayError) {
      var _props$fieldItem2;
      return "".concat(i18n.t('REGISTRATION.IS_REQUIRED', {
        displayName: getValidationMessage(props === null || props === void 0 || (_props$fieldItem2 = props.fieldItem) === null || _props$fieldItem2 === void 0 ? void 0 : _props$fieldItem2.fieldLabel)
      }));
    } else {
      var _props$fieldItem3;
      return props === null || props === void 0 || (_props$fieldItem3 = props.fieldItem) === null || _props$fieldItem3 === void 0 ? void 0 : _props$fieldItem3.fieldError;
    }
  };
  var gethelperInfo = function gethelperInfo() {
    var _props$fieldItem4, _props$fieldItem6;
    var charLimit = '';
    if (i18n.t(String(props === null || props === void 0 || (_props$fieldItem4 = props.fieldItem) === null || _props$fieldItem4 === void 0 ? void 0 : _props$fieldItem4.charLimit))) {
      var _props$fieldItem5;
      charLimit = i18n.t(String(props === null || props === void 0 || (_props$fieldItem5 = props.fieldItem) === null || _props$fieldItem5 === void 0 ? void 0 : _props$fieldItem5.charLimit));
    }
    return "".concat(i18n.t(String(props === null || props === void 0 || (_props$fieldItem6 = props.fieldItem) === null || _props$fieldItem6 === void 0 ? void 0 : _props$fieldItem6.helperText), {
      charLimit: charLimit
    }));
  };
  if (getFieldError()) {
    var _props$fieldItem7;
    props.fieldItem.fieldError = "".concat(i18n.t('REGISTRATION.IS_INVALID', {
      displayName: getValidationMessage(props === null || props === void 0 || (_props$fieldItem7 = props.fieldItem) === null || _props$fieldItem7 === void 0 ? void 0 : _props$fieldItem7.fieldLabel)
    }));
  } else if (props !== null && props !== void 0 && props.fieldValue && props !== null && props !== void 0 && (_props$fieldItem8 = props.fieldItem) !== null && _props$fieldItem8 !== void 0 && _props$fieldItem8.minLength && (props === null || props === void 0 || (_props$fieldValue = props.fieldValue) === null || _props$fieldValue === void 0 ? void 0 : _props$fieldValue.length) < (props === null || props === void 0 || (_props$fieldItem9 = props.fieldItem) === null || _props$fieldItem9 === void 0 ? void 0 : _props$fieldItem9.minLength)) {
    var _props$fieldItem10;
    props.fieldItem.fieldError = i18n.t('REGISTRATION.IS_INVALID', {
      displayName: i18n.t(props === null || props === void 0 || (_props$fieldItem10 = props.fieldItem) === null || _props$fieldItem10 === void 0 ? void 0 : _props$fieldItem10.fieldLabel)
    });
  } else if (props !== null && props !== void 0 && props.fieldValue && props !== null && props !== void 0 && (_props$fieldItem11 = props.fieldItem) !== null && _props$fieldItem11 !== void 0 && _props$fieldItem11.charLimit && (props === null || props === void 0 || (_props$fieldValue2 = props.fieldValue) === null || _props$fieldValue2 === void 0 ? void 0 : _props$fieldValue2.length) > (props === null || props === void 0 || (_props$fieldItem12 = props.fieldItem) === null || _props$fieldItem12 === void 0 ? void 0 : _props$fieldItem12.charLimit)) {
    var _props$fieldItem13;
    props.fieldItem.fieldError = i18n.t('REGISTRATION.COUNT_VALIDATION', {
      countValue: props === null || props === void 0 || (_props$fieldItem13 = props.fieldItem) === null || _props$fieldItem13 === void 0 ? void 0 : _props$fieldItem13.charLimit
    });
  }
  var fieldMandatoryError = (props === null || props === void 0 || (_props$fieldItem14 = props.fieldItem) === null || _props$fieldItem14 === void 0 ? void 0 : _props$fieldItem14.mandatory) && isEmpty(props === null || props === void 0 ? void 0 : props.fieldValue);
  var errorFlag = !!fieldMandatoryError || !!(props !== null && props !== void 0 && (_props$fieldItem15 = props.fieldItem) !== null && _props$fieldItem15 !== void 0 && _props$fieldItem15.fieldError);
  handleErr(props === null || props === void 0 || (_props$fieldItem16 = props.fieldItem) === null || _props$fieldItem16 === void 0 ? void 0 : _props$fieldItem16.fieldName, errorFlag, props === null || props === void 0 ? void 0 : props.errorDetails);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    key: props === null || props === void 0 ? void 0 : props.index,
    disabled: props === null || props === void 0 || (_props$fieldItem17 = props.fieldItem) === null || _props$fieldItem17 === void 0 ? void 0 : _props$fieldItem17.disabled,
    select: (props === null || props === void 0 || (_props$fieldItem18 = props.fieldItem) === null || _props$fieldItem18 === void 0 ? void 0 : _props$fieldItem18.fieldType) === 'select' ? true : false,
    className: (props === null || props === void 0 || (_props$fieldItem19 = props.fieldItem) === null || _props$fieldItem19 === void 0 ? void 0 : _props$fieldItem19.fieldType) === 'select' ? 'user-input-select-field' : 'user-input-field',
    label: i18n.t(props === null || props === void 0 || (_props$fieldItem20 = props.fieldItem) === null || _props$fieldItem20 === void 0 ? void 0 : _props$fieldItem20.fieldLabel) + (props !== null && props !== void 0 && (_props$fieldItem21 = props.fieldItem) !== null && _props$fieldItem21 !== void 0 && _props$fieldItem21.mandatory ? ' *' : ''),
    InputLabelProps: {
      shrink: true
    },
    SelectProps: {
      "native": true,
      IconComponent: function IconComponent() {
        return dropDownComponent(props === null || props === void 0 ? void 0 : props.environment, props === null || props === void 0 ? void 0 : props.fieldItem.disabled);
      }
    },
    name: props === null || props === void 0 || (_props$fieldItem22 = props.fieldItem) === null || _props$fieldItem22 === void 0 ? void 0 : _props$fieldItem22.fieldName,
    color: "primary",
    variant: (props === null || props === void 0 || (_props$fieldItem23 = props.fieldItem) === null || _props$fieldItem23 === void 0 ? void 0 : _props$fieldItem23.fieldType) === 'select' ? 'filled' : 'standard',
    size: "small",
    inputProps: {
      maxLength: props === null || props === void 0 || (_props$fieldItem24 = props.fieldItem) === null || _props$fieldItem24 === void 0 ? void 0 : _props$fieldItem24.charLimit
    },
    value: !(props !== null && props !== void 0 && props.fieldValue) ? '' : props === null || props === void 0 ? void 0 : props.fieldValue,
    onChange: function onChange(event) {
      var _props$fieldItem25;
      return props === null || props === void 0 ? void 0 : props.inputHandler(event, props === null || props === void 0 || (_props$fieldItem25 = props.fieldItem) === null || _props$fieldItem25 === void 0 ? void 0 : _props$fieldItem25.regexPattern, props === null || props === void 0 ? void 0 : props.fieldItem);
    },
    onInput: function onInput(event) {
      var _props$fieldItem26;
      return props === null || props === void 0 ? void 0 : props.inputHandler(event, props === null || props === void 0 || (_props$fieldItem26 = props.fieldItem) === null || _props$fieldItem26 === void 0 ? void 0 : _props$fieldItem26.regexPattern, props === null || props === void 0 ? void 0 : props.fieldItem);
    },
    onBlur: function onBlur(event) {
      var _props$fieldItem27;
      if (props !== null && props !== void 0 && props.blurHandler) props === null || props === void 0 || props.blurHandler(event);
      if (props !== null && props !== void 0 && props.blurHandlerWithRegex) props === null || props === void 0 || props.blurHandlerWithRegex(event, props === null || props === void 0 || (_props$fieldItem27 = props.fieldItem) === null || _props$fieldItem27 === void 0 ? void 0 : _props$fieldItem27.regexPattern, props === null || props === void 0 ? void 0 : props.fieldItem);
    },
    helperText: getHelperText(fieldMandatoryError),
    error: props !== null && props !== void 0 && props.fieldValue ? errorFlag : false
  }, isEmpty(props === null || props === void 0 || (_props$fieldItem28 = props.fieldItem) === null || _props$fieldItem28 === void 0 ? void 0 : _props$fieldItem28.selectOptions) && (props === null || props === void 0 ? void 0 : props.optionDisplay(props === null || props === void 0 || (_props$fieldItem29 = props.fieldItem) === null || _props$fieldItem29 === void 0 ? void 0 : _props$fieldItem29.fieldLabel)), !isEmpty(props === null || props === void 0 || (_props$fieldItem30 = props.fieldItem) === null || _props$fieldItem30 === void 0 ? void 0 : _props$fieldItem30.selectOptions) && (props === null || props === void 0 || (_props$fieldItem31 = props.fieldItem) === null || _props$fieldItem31 === void 0 ? void 0 : _props$fieldItem31.fieldType) === 'select' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, i18n.t('REGISTRATION.SELECT')), props === null || props === void 0 || (_props$fieldItem32 = props.fieldItem) === null || _props$fieldItem32 === void 0 || (_props$fieldItem32 = _props$fieldItem32.selectOptions) === null || _props$fieldItem32 === void 0 ? void 0 : _props$fieldItem32.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option.displayName,
      value: option.value
    }, option.displayName);
  }))), (props === null || props === void 0 || (_props$fieldItem33 = props.fieldItem) === null || _props$fieldItem33 === void 0 ? void 0 : _props$fieldItem33.helperText) && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: 'flex-end'
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "secondary.dark",
    sx: {
      fontSize: '0.7rem'
    },
    component: 'p'
  }, gethelperInfo())));
};
export default TextFieldComponent;